var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "material-layout--container",
      class: {
        "material-layout--error": _vm.hasError,
        "material-layout--side-grid": _vm.sideGrid,
      },
    },
    [
      _c(
        "div",
        { staticClass: "materia-layout--label-wrapper" },
        [
          _vm.$slots["label"] ? _vm._t("label") : _vm._e(),
          _vm._v(" "),
          _vm.$slots["label"] && _vm.showRequiredIndicator && _vm.isRequired
            ? _c("input-required-indicator")
            : _c("span", [_vm._v("‌")]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "materia-layout--content-wrapper" }, [
        _vm.$slots["before-input"]
          ? _c(
              "span",
              { staticClass: "material-layout--before-input pr-1" },
              [_vm._t("before-input")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "material-layout--input-container",
            class: {
              "material-layout--input--focus": _vm.hasFocus,
              disabled: _vm.disabled,
              radio: _vm.radio,
            },
          },
          [
            _vm.$slots["prepend-input"]
              ? _c(
                  "span",
                  { staticClass: "material-layout--prepend-input pr-1" },
                  [_vm._t("prepend-input")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default"),
            _vm._v(" "),
            !_vm.noUnderline
              ? _c("span", { staticClass: "material-layout--input-bar" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "transition",
              {
                attrs: {
                  "enter-active-class": "animated fadeIn faster",
                  "leave-active-class": "animated fadeOut faster",
                },
              },
              [
                _vm.hasError
                  ? _c(
                      "span",
                      { staticClass: "material-layout--error-message" },
                      [
                        _vm._t("error-message", function () {
                          return [_vm._v(_vm._s(_vm.errorMessage))]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "transition",
              {
                attrs: {
                  "enter-active-class": "animated fadeIn faster",
                  "leave-active-class": "animated fadeOut faster",
                },
              },
              [
                _vm.$slots["append-input"] || _vm.hasError
                  ? _c(
                      "span",
                      { staticClass: "material-layout--append-input pl-1" },
                      [
                        _vm._t("append-input"),
                        _vm._v(" "),
                        _vm.hasError && !_vm.noErrorIcon
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "material-layout--input--invalid-icon",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-circle text-danger",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _vm.$slots["after-input"]
          ? _c(
              "span",
              { staticClass: "material-layout--after-input pl-1" },
              [_vm._t("after-input")],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }